var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,4A20,20,0,1,0,44,24,20,20,0,0,0,24,4ZM34.6066,33.1924l-1.4142,1.414L24,25.4141l-9.1924,9.1923-1.4142-1.414L22.5858,24l-9.1924-9.1924,1.4142-1.414L24,22.5859l9.1924-9.1923,1.4142,1.414L25.4142,24Z",
    fill: "#d40511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/errorCircle.3396919dcfc228f1196e4328a0dbcc8b.svg";
export { ForwardRef as ReactComponent };